import { render, staticRenderFns } from "./CameraErrorLayout.vue?vue&type=template&id=53fba00c&scoped=true"
import script from "./CameraErrorLayout.vue?vue&type=script&lang=js"
export * from "./CameraErrorLayout.vue?vue&type=script&lang=js"
import style0 from "./CameraErrorLayout.vue?vue&type=style&index=0&id=53fba00c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fba00c",
  null
  
)

export default component.exports